import FixedAssetAPI from './_fixedAssetApi.js';

class FAIncrementDecrementAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FaIncrementDecrements';
}

export default new FAIncrementDecrementAPI();
